import { useState } from "react";
import PropTypes from 'prop-types';
import { Row, List, Col, Progress, Tooltip, Modal, Typography } from 'antd';
import { ExclamationCircleTwoTone, MoreOutlined } from '@ant-design/icons';
import Box from '../../components/utility/box';
import IntlMessages from '../../components/utility/intlMessages';
import moment from "moment";
import { DISPLAY_DATE_TIME_FORMAT } from "../../helpers/utility";

const { Title } = Typography;

const COLORS = {
  "INFO": "#6666ff",
  "ERROR": "#e50000",
  "DEBUG": "#329932",
  "WARNING": "#FFA500"
};

function BackgroundLogs(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState([]);

  function openModal(record) {
    setSelectedRecord(record)
    setModalVisible(visible => !visible);
  }

  function closeModal() {
    setSelectedRecord([])
    setModalVisible(visible => !visible);
  }


  function backgroundJobLogListItemFactory(record, containsError, isMainDisplay, initialRecord = []) {
    /**
     * We render only the first value from logs. 
     * Main display means that the item is rendered in the main view
     * and not in the modal that contains all the log items of the job.
     * The initialRecord variable is used only when isMainDisplay is true. 
     * We assign its value to state in order to render all logs inside modal. 
     */
    const getLevel = (level) => {
      const color = COLORS[level];
      return <div style={{ color: color }}>{level}</div>
    }

    const getProgressStatus = (level, percentage) => {
      let status;

      const mapper = {
        "INFO": "active",
        "ERROR": "exception"
      }

      if (percentage === 100) {
        status = "success";
      } else {
        status = mapper[level];
      }
      return status;
    }

    const progressStatus = getProgressStatus(record.level, record.percentage);

    return (
      <List.Item>
        <Row style={{ width: "100%" }} gutter={[16, 16]}>
          <Col span={5} style={{ wordWrap: "break-word" }}> {record.type}
          </Col>
          <Col span={2} style={{ wordWrap: "break-word" }}>
            <IntlMessages id="homePage.backgrounLogs.jobId" />: {record.jobId}
          </Col>
          <Col span={2} style={{ wordWrap: "break-word" }}>
            {
              isMainDisplay && containsError &&
              <Tooltip title={<IntlMessages id="homePage.backgrounLogs.containsError" />}>
                <ExclamationCircleTwoTone twoToneColor={'red'} />
              </Tooltip>
            }
          </Col>
          <Col span={2} style={{ wordWrap: "break-word" }}>
            {getLevel(record.level)}
          </Col>
          <Col span={5} style={{ wordWrap: "break-word" }}> {record.message}
          </Col>
          <Col span={7}>
            <Row gutter={[16, 16]}>
              <Col span={24} style={{ wordWrap: "break-word" }}>
                <IntlMessages id="homePage.backgrounLogs.userId" />: {record.userId}
              </Col>
              <Col span={24} style={{ wordWrap: "break-word" }}>
                <IntlMessages id="homePage.backgrounLogs.datetime" />: {moment(record.datetime).format(DISPLAY_DATE_TIME_FORMAT)}
              </Col>
              <Col span={24} style={{ wordWrap: "break-word" }}>
                <Progress percent={record.percentage} status={progressStatus} />
              </Col>
            </Row>
          </Col>
          {isMainDisplay && <Col span={1}>
            <MoreOutlined onClick={() => openModal(initialRecord['logs'])} />
          </Col>}
        </Row>
      </List.Item>
    )
  }

  return (
    <Box>
      <Row>
        <Col span={24}>
          {props.showTitle && <Title level={4} style={{ textAlign: "center" }}>
            <IntlMessages id="homePage.backgrounLogs.title" />
          </Title>}
          <List
            style={{ maxHeight: "700px", overflowY: 'auto' }}
            dataSource={props.data}
            renderItem={record => backgroundJobLogListItemFactory(record.logs[0], record.containsError, true, record)}
          />

          <Modal visible={modalVisible} onCancel={closeModal} onOk={closeModal} width={1200} closable={false} footer={null}>
            <List
              dataSource={selectedRecord}
              bordered
              renderItem={(record) => backgroundJobLogListItemFactory(record, false, false)}
            />
          </Modal>
        </Col>
      </Row>
    </Box>
  )
}

BackgroundLogs.propTypes = {
  data: PropTypes.array.isRequired,

  showTitle: PropTypes.bool,
};

BackgroundLogs.defaultProps = {
  data: [],
  showTitle: true
}

export default BackgroundLogs;